import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import type { PaperProps } from '@mui/material/Paper';
import { MOVE_FORWARD_COPY, MOVE_FORWARD_FALLBACK_COPY } from './constants';
import { MoveForwardDialogProps } from './types';

const MoveForwardDialog = ({ open, status, onClose, onContinue }: MoveForwardDialogProps) => {
  const { title, description } = MOVE_FORWARD_COPY[status] ?? MOVE_FORWARD_FALLBACK_COPY;

  return (
    <Dialog
      aria-describedby="move-forward-dialog-description"
      aria-labelledby="move-forward-dialog-title"
      onClose={onClose}
      open={open}
      slotProps={{
        paper: { 'data-testid': 'move-forward-confirmation-dialog' } as PaperProps,
      }}
    >
      <DialogTitle id="move-forward-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="move-forward-dialog-description">{description}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button color="inherit" onClick={onClose}>
          Cancel
        </Button>
        <Button
          color="error"
          onClick={() => {
            onClose();
            onContinue();
          }}
          variant="contained"
        >
          Continue
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MoveForwardDialog;
